import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { concreteBaseService } from "Dashboard/scenes/ConcreteBase/services/concreteBase.service";

interface IRepositoryOption {
  label: string;
  value: number;
  shortName: string;
}

const RepositorySelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [options, setOptions] = useState<IRepositoryOption[]>([]);
  const [value, setValue] = useState<IRepositoryOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      try {
        const repositories = await concreteBaseService.getRepositoriesForConcreteBase();
        const op = repositories
          .filter(repository =>
            props.allowedRepositories === undefined
            || props.allowedRepositories.includes(repository.shortName))
          .map((repository) => {
            return {
              label: repository.name,
              value: repository.repositoryId,
              shortName: repository.shortName,
            };
          });
        setOptions(op);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
      }
    }
    getData();
  }, []);

  useEffect(() => {
    if (props.fixedRepository) {
      const values = options.filter((o) => o.shortName === props.fixedRepository);
      if (values[0]) {
        setValue(values[0]);
        props.onChange(values[0].value);
        setIsDisabled(true);
      }
    }
  }, [options, props.fixedRepository, props]);


  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
    if (props.onChangeShortName) {
      props.onChangeShortName(newValue ? newValue.shortName : null);
    }
  };

  return (
    <Select
      isClearable
      isDisabled={isDisabled}
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      options={options}
      value={value}
      onChange={handleChange}
      placeholder={""}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default RepositorySelect;
